import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="about-us-container">
      {/* Breadcrumb */}
      <div className="breadcrumb">
        <span>Home</span> → <span className="current">About Us</span>
      </div>

      {/* Who We Are Section */}
      <section className="content-section">
        <div className="text-content">
          <h2 className="main-heading">WHO WE ARE</h2>
          <h3 className="subheading">Passionate about SAP Consulting and Innovation</h3>
          <p>
            At Ensuresap, we pride ourselves on our deep expertise in SAP consulting. From implementation to optimization, our team ensures that your business achieves its goals with minimal downtime and maximum efficiency.
          </p>
          <p>
            Our commitment to quality drives everything we do, helping our clients unlock their potential and thrive in a competitive market. Let us help you on your journey to success.
          </p>
        </div>
        <div className="image-content">
          <img src="/assets/about-us-illustration.jpg" alt="Consulting Team" />
        </div>
      </section>
      {/* Our Mission Section1 */}
      <section className="our-mission-section1">
  <video className="mission-video1" autoPlay loop muted playsInline>
    <source src="/assets/background-video.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>
  <div className="mission-content1">
    <h2 className="mission-heading1">OUR MISSION</h2>
    <p className="mission-text1">
      “To empower businesses in unlocking their full potential through innovative SAP solutions, seamless data integration, and AI-driven optimization. Our mission is to deliver customized strategies and cutting-edge technologies that drive operational excellence, enhance decision-making, and create sustainable value for our clients in an ever-evolving digital landscape.”
    </p>
  </div>
</section>


            {/* Why Choose Us Section */}
            <section className="why-choose-us">
                <h2 className="section-heading">Why Choose Ensuresap Consulting?</h2>
                <div className="reasons">
                    <div className="reason">
                        <h3>Expertise in SAP</h3>
                        <p>Decades of experience across SAP modules and solutions.</p>
                    </div>
                    <div className="reason">
                        <h3>Industry Knowledge</h3>
                        <p>Deep understanding of industry-specific challenges and needs.</p>
                    </div>
                    <div className="reason">
                        <h3>Innovative Solutions</h3>
                        <p>Cutting-edge AI and data analytics for informed decision-making.</p>
                    </div>
                    <div className="reason">
                        <h3>Client-Centric Approach</h3>
                        <p>A personalized approach to deliver exceptional results.</p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AboutUs;